import React from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import LibraryTagDisplay from 'components/pure/call-card/LibraryTagDisplay';
import {Library} from '@store/@types/records/Library';
import {TagData} from 'stores/files/FileUploadStore';
import {SetState} from '@store/@types/util/React';
import {FileUploadId} from 'records/CoachingReviewFileUpload';
import {List} from 'immutable';

interface LibraryTagInputProps {
  library: Library | null;
  tags: List<TagData>;
  selectedTags: string[];
  setSelectedTags: SetState<string[]>;
  callId: FileUploadId;
}

export const LibraryTagInput: React.FC<LibraryTagInputProps> = ({
  library,
  tags,
  selectedTags,
  setSelectedTags,
  callId,
}) => {
  const savedTags = tags.filter(t => library?.id === t.library_id.toString());
  const savedSet = savedTags.map(t => t.tag_name).toSet();
  const canCreateTags = library?.permissions.includes('create_tags');

  return (
    <>
      <div className="library-tab-label">Add any applicable tags</div>
      <div className="tag-selector">
        <Autocomplete
          value={selectedTags}
          filterSelectedOptions
          multiple
          noOptionsText={
            canCreateTags
              ? "Couldn't find any matching tags. Press Enter to add this tag."
              : "Couldn't find any matching tags. You do not have permission to create new tags."
          }
          freeSolo={canCreateTags}
          options={library?.tags.filter(t => !savedSet.has(t)) ?? []}
          onChange={(e, value) => setSelectedTags(value)}
          renderInput={params => (
            <TextField
              className="library-tab-select-input"
              {...params}
              size="small"
              fullWidth={false}
              variant="outlined"
            />
          )}
        />
      </div>
      {canCreateTags && <div className="can-create"> (Press enter to add a new tag)</div>}
      {library && !savedTags.isEmpty() && (
        <div className="saved-tags">
          <p>This call is already in {library.name} with these tags:</p>
          <LibraryTagDisplay fileUploadId={callId} libraryId={library.id} />
        </div>
      )}
    </>
  );
};
